const USER_POOL_ID = 'us-east-1_ImI1bvmVS'
const REGION = USER_POOL_ID.split('_')[0]

function getClientId() {
  return (
    process.env.VUE_APP_COGNITO_CLIENT_ID ||
    window.__WALL_LABS_COGNITO_CLIENT_ID__ ||
    ''
  )
}

export async function loginWithCognito(username, password) {
  const clientId = getClientId()

  if (!clientId) {
    throw new Error(
      'Missing Cognito App Client ID.'
    )
  }

  const endpoint = `https://cognito-idp.${REGION}.amazonaws.com/`
  const response = await fetch(endpoint, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/x-amz-json-1.1',
      'X-Amz-Target': 'AWSCognitoIdentityProviderService.InitiateAuth'
    },
    body: JSON.stringify({
      AuthFlow: 'USER_PASSWORD_AUTH',
      ClientId: clientId,
      AuthParameters: {
        USERNAME: username,
        PASSWORD: password
      }
    })
  })

  const data = await response.json()
  if (!response.ok) {
    const message =
      data?.message ||
      data?.Message ||
      data?.__type ||
      'Authentication failed.'
    throw new Error(message)
  }

  return {
    userPoolId: USER_POOL_ID,
    region: REGION,
    authResult: data.AuthenticationResult || null,
    challengeName: data.ChallengeName || null,
    session: data.Session || null
  }
}

export async function completeNewPasswordChallenge({
  username,
  newPassword,
  session
}) {
  const clientId = getClientId()

  if (!clientId) {
    throw new Error('Missing Cognito App Client ID.')
  }

  if (!session) {
    throw new Error('Missing Cognito challenge session.')
  }

  const endpoint = `https://cognito-idp.${REGION}.amazonaws.com/`
  const response = await fetch(endpoint, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/x-amz-json-1.1',
      'X-Amz-Target': 'AWSCognitoIdentityProviderService.RespondToAuthChallenge'
    },
    body: JSON.stringify({
      ChallengeName: 'NEW_PASSWORD_REQUIRED',
      ClientId: clientId,
      Session: session,
      ChallengeResponses: {
        USERNAME: username,
        NEW_PASSWORD: newPassword
      }
    })
  })

  const data = await response.json()
  if (!response.ok) {
    const message =
      data?.message ||
      data?.Message ||
      data?.__type ||
      'Failed to set new password.'
    throw new Error(message)
  }

  return {
    authResult: data.AuthenticationResult || null,
    challengeName: data.ChallengeName || null,
    session: data.Session || null
  }
}

export async function requestPasswordReset(username) {
  const clientId = getClientId()

  if (!clientId) {
    throw new Error('Missing Cognito App Client ID.')
  }

  const endpoint = `https://cognito-idp.${REGION}.amazonaws.com/`
  const response = await fetch(endpoint, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/x-amz-json-1.1',
      'X-Amz-Target': 'AWSCognitoIdentityProviderService.ForgotPassword'
    },
    body: JSON.stringify({
      ClientId: clientId,
      Username: username
    })
  })

  const data = await response.json()
  if (!response.ok) {
    const message =
      data?.message ||
      data?.Message ||
      data?.__type ||
      'Failed to send reset code.'
    throw new Error(message)
  }

  return {
    codeDeliveryDetails: data.CodeDeliveryDetails || null
  }
}

export async function confirmPasswordReset({
  username,
  confirmationCode,
  newPassword
}) {
  const clientId = getClientId()

  if (!clientId) {
    throw new Error('Missing Cognito App Client ID.')
  }

  const endpoint = `https://cognito-idp.${REGION}.amazonaws.com/`
  const response = await fetch(endpoint, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/x-amz-json-1.1',
      'X-Amz-Target': 'AWSCognitoIdentityProviderService.ConfirmForgotPassword'
    },
    body: JSON.stringify({
      ClientId: clientId,
      Username: username,
      ConfirmationCode: confirmationCode,
      Password: newPassword
    })
  })

  const data = await response.json()
  if (!response.ok) {
    const message =
      data?.message ||
      data?.Message ||
      data?.__type ||
      'Failed to reset password.'
    throw new Error(message)
  }

  return { success: true }
}

export { USER_POOL_ID, REGION }
